import { render, staticRenderFns } from "./MarcadorDeIdentacao.vue?vue&type=template&id=6b06be74&scoped=true"
import script from "./MarcadorDeIdentacao.vue?vue&type=script&lang=js"
export * from "./MarcadorDeIdentacao.vue?vue&type=script&lang=js"
import style0 from "./MarcadorDeIdentacao.vue?vue&type=style&index=0&id=6b06be74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06be74",
  null
  
)

export default component.exports